import { registerHandler } from "../handler";
import { LibCategories, waitForConsent } from "@utils/consent";

const ARTSAI_LEAD_PIXEL =
  "https://arttrk.com/pixel/?ad_log=referer&action=signup&pixid=19910173-112a-4492-83f9-b1f3d3836eb1";
const ARTSAI_PURCHASE_PIXEL =
  "https://arttrk.com/pixel/?ad_log=referer&action=purchase&pixid=19910173-112a-4492-83f9-b1f3d3836eb1";

function fireArtsAiPixel(url: string) {
  const artsAiPixel = document.createElement("img");
  artsAiPixel.setAttribute("id", "artsAi-pixel");

  artsAiPixel.setAttribute("src", url);
  artsAiPixel.setAttribute("height", "1px");
  artsAiPixel.setAttribute("width", "1px");
  artsAiPixel.setAttribute("style", "display:none;");
  artsAiPixel.setAttribute("alt", "");

  document.body.appendChild(artsAiPixel);
}

export default function registerHandlers() {
  registerHandler("lead", () => {
    waitForConsent([LibCategories.targetingCookies]).then(() =>
      fireArtsAiPixel(ARTSAI_LEAD_PIXEL)
    );
  });

  registerHandler("purchase", () => {
    waitForConsent([LibCategories.targetingCookies]).then(() =>
      fireArtsAiPixel(ARTSAI_PURCHASE_PIXEL)
    );
  });
}
